'use client';
import { Button } from '@/components/ui/button';
import copy from 'copy-to-clipboard';
import { Copy } from 'lucide-react';
import React from 'react';
import { toast } from 'sonner';

const CopyButton = ({ text }: { text: string }) => {
  return (
    <Button
      size="icon"
      variant="ghost"
      className="rounded-full h-8 w-8"
      onClick={() => {
        copy(text);
        toast.success('复制成功', {
          position: 'top-center',
        });
      }}
    >
      <Copy size={16} className="w-4 h-4" />
    </Button>
  );
};

export default CopyButton;
